import request from '@/utils/request'

export function getPersonalInfor(id) {
  return request({
    url: `/sys/user/${id}`,
    method: 'get'
  })
}
export function upDataPersonalInfor(data) {
  return request({
    url: `/sys/user/updateCurrentUserInfo`,
    method: 'put',
    data
  })
}
export function upDataAvatar(){
  return request({
    url:`/sys/user/saveUserAvatar/${userId}/${fileId}`,
    method: 'post',
  })
}
